import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddProductSlice = createSlice({
    name: "addProduct",
    initialState,
    reducers: {
        addProductRequest(state) {
            state.loading = true;
        },
        addProductRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addProductRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        addProductStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    addProductRequest,
    addProductRequestSuccess,
    addProductRequestError,
    addProductStateReset
} = AddProductSlice.actions;

export default AddProductSlice.reducer;
